// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"fa4bf478","464":"76521341","787":"5128b469"}[chunkId] + ".chunk.js";
};